import moment from 'jalali-moment';

export const concatDates = (
  postChartData: IGetPostChart[] | undefined,
  AuctionSuggestionData: ISuggestionChart[] | undefined,
) => {
  const dateArraypostChart = postChartData
    ? postChartData?.map(item => item.date)
    : [];

  const dateArrayAuctionSuggestion = AuctionSuggestionData
    ? AuctionSuggestionData.map(item => item.created_at__date)
    : [];

  const concatedArray = dateArraypostChart.concat(dateArrayAuctionSuggestion);

  return concatedArray
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort(function (a, b) {
      const da = new Date(a).getTime();
      const db = new Date(b).getTime();
      return da < db ? -1 : da > db ? 1 : 0;
    })
    .map(item => moment(item).format('jYYYY/jMM/jDD'));
};
interface Ilist {
  count: number;
  date: string;
}
export const calculateUndefindValue = (
  theList: Array<Ilist>,
  dateList: Array<string>,
): Array<Ilist> => {
  const newArray = dateList.map(item => handleUndefindValue(item, theList));
  return newArray;
};

const handleUndefindValue = (item: string, theList: Array<Ilist>) => {
  if (theList.some(m => moment(m.date).format('jYYYY/jMM/jDD') === item)) {
    const foundedItem = theList.find(
      x => moment(x.date).format('jYYYY/jMM/jDD') === item,
    );
    return foundedItem
      ? {
          date: moment(foundedItem.date).format('jYYYY/jMM/jDD'),
          count: foundedItem.count,
        }
      : {
          date: item,
          count: 0,
        };
  } else {
    return {
      date: item,
      count: 0,
    };
  }
};

export const calclulateTotal = (dataArray: Array<ISuggestionChart>) => {
  let sum = 0;
  dataArray?.forEach(item => {
    sum += item.count;
  });
  return sum;
};
